export default "__VITE_ASSET__29843434__"